function slugifyName(name) {
  return name.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-');
}

function initTableData(entry) {
  var slug = slugifyName(entry[0]);
  var pl = entry[2];
  var plPercent = entry[3];

  var classNameDol = pl.indexOf('-') === 0 ? 'loss' : pl === '$0.00' ? '' : 'win';
  var classNamePercent = plPercent.indexOf('-') === 0 ? 'loss' : plPercent === '0.00%' ? '' : 'win';

  $('#js-' + slug + '-data').text(pl).removeClass('win loss').addClass(classNameDol);
  $('#js-' + slug + '-percent').text(plPercent).removeClass('win loss').addClass(classNamePercent);
}

function initTable() {
  var leaderboard = 'https://sheets.googleapis.com/v4/spreadsheets/1nL9YfMaN0gmqTCjgT4X9oaMm0qIJoeSAr8svPyFp-vw/values/LEADERBOARD?alt=json&key=AIzaSyAFQQF4VhJMR417rPpjrt5DBOqnM1M0FPo';

  $.get(leaderboard).done(function(data) {
    var entries = data.values;

    $.each(entries.slice(1), function(_, entry) {
      initTableData(entry);
    });
  });
}

function initTimer() {
  var $timerEl = $('#jsTimer');
  var timeRemaining = 45 * 60; // 45 minutes in seconds
  var intervalId = null;

  function formatTime(seconds) {
    var mins = Math.floor(seconds / 60);
    var secs = seconds % 60;
    return (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
  }

  function updateDisplay() {
    $timerEl.text(formatTime(timeRemaining));
  }

  function startCountdown() {
    if (intervalId) return;
    
    $timerEl.attr('data-timer', 'on');
    
    intervalId = setInterval(function() {
      timeRemaining--;
      updateDisplay();
      
      if (timeRemaining <= 0) {
        clearInterval(intervalId);
        intervalId = null;
        $timerEl.attr('data-timer', 'off');
        console.log('Timer finished!');
      }
    }, 1000);
  }

  function stopCountdown() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
      $timerEl.attr('data-timer', 'off');
    }
  }

  updateDisplay();
  startCountdown();

  $timerEl.on('click', function() {
    if (intervalId) {
      stopCountdown();
    } else if (timeRemaining > 0) {
      startCountdown();
    }
  });
}

var pollingInterval = null;

function checkTimerStatus() {
  $.get('https://verifiedinvesting.com/pages/crypto-combat-rekt-or-rich').done(function(data) {
    var $timerStatusEl = $(data).find('#jsIsTimerOn');
    var timerStatus = $timerStatusEl.val();
    
    console.log('Timer status:', timerStatus);
    
    // Update local value
    $('#jsIsTimerOn').val(timerStatus);
    
    // If timer is now true, stop polling and start timer
    if (timerStatus === 'true') {
      if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
      }
      initTimer();
    }
  });
}

$(function() {
  'use strict';

  setInterval(function() {
      initTable();
  }, 2000);

  var timerStatus = $('#jsIsTimerOn').val();

  if (timerStatus === 'true') {
    // Timer is already on, start immediately
    initTimer();
  } else {
    // Timer is off, start polling every 3 seconds
    pollingInterval = setInterval(checkTimerStatus, 1000);
    // Also check immediately
    checkTimerStatus();
  }
});